import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { CallbackResult, CallbackResultStatus } from '../../../../../../../../../utils';
import { AccountService } from '../../../../../../../../../services/account/account.service';
import { LocationService } from '../../../../../../../../../services/location/location.service';
import { CapitanLocation } from '../../../../../../../../../models/location';


@Component({
  selector: 'app-add-stripe-reader-modal',
  templateUrl: './add-stripe-reader-modal.component.html',
  styleUrls: ['./add-stripe-reader-modal.component.css']
})
export class AddStripeReaderModalComponent implements OnInit {

  @Input() location: CapitanLocation;
  @Input() savedCallback: (result: CallbackResult) => undefined;

  public registrationCode = '';
  public label = '';

  public loadingSubmit = false;
  public errorMessage = '';

  public serverError: number = null;

  constructor(
    public accountService: AccountService,
    public activeModal: NgbActiveModal,
    public locationService: LocationService
  ) {}

  ngOnInit() {
    if (!this.accountService.getMyAccount().is_organization_admin) {
      return;
    }
  }

  public handleSave() {
    this.loadingSubmit = true;

    this.errorMessage = '';

    this.locationService
      .addStripeReader(
        this.registrationCode,
        this.label,
        this.location.id
      )
      .then(createdReader => {
        this.savedCallback({
          text: createdReader.label + ' added successfully.',
          status: CallbackResultStatus.success
        });
        this.activeModal.close();
      })
      .catch(reason => {
        if (reason.status === 400) {
          this.errorMessage = reason.error;
        } else if (reason.status === 403) {
          this.errorMessage = 'You do not have permission to add payment terminals.';
        } else {
          this.serverError = reason.status;
        }
      })
      .finally(() => { this.loadingSubmit = false; });
  }

}
